import React from 'react'
import {graphql} from 'react-apollo'
import {get} from 'lodash'
import CustomShippingSection from './components/customShippingSection'
import {GET_DEFAULT_SHIPPING_METHOD} from '../../../../../graphql/query'

class ShippingContent extends React.Component {
  render() {
    return (
      <div style={{padding: 32}}>
        {(() => {
          if (!this.props.data.loading) {
            return (
              <div>
                <CustomShippingSection projectId={this.props.projectId} />
              </div>
            )
          }
          return <div />
        })()}
      </div>
    )
  }
}

export default graphql(GET_DEFAULT_SHIPPING_METHOD, {
  props: props => {
    const {data} = props
    const standardShipping = get(data, 'defaultShippingMethod.0', null)
    const expressShipping = get(data, 'defaultShippingMethod.1', null)
    return {
      data,
      initialValues: {
        standardEnabled: !get(standardShipping, 'disabled'),
        standardShippingPrice: get(standardShipping, 'fixedPrice'),
        standardShippingDuration: get(standardShipping, 'maxDuration'),
        standardShippingDescription: get(standardShipping, 'description'),
        expressEnabled: !get(expressShipping, 'disabled'),
        expressShippingPrice: get(expressShipping, 'fixedPrice'),
        expressShippingDuration: get(expressShipping, 'maxDuration'),
        expressShippingDescription: get(expressShipping, 'description'),
      },
    }
  },
  options: props => {
    return {
      variables: {
        projectId: props.projectId,
      },
    }
  },
})(ShippingContent)



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/shipping/ShippingContent.js